{
    "mcpPermissions": {
        "menu": "Autorisations des outils MCP",
        "title": "Autorisations des outils MCP",
        "info": {
            "interim": "Une liste d’autorisations vide accorde actuellement TOUS les outils (politique provisoire). Pour réellement restreindre un utilisateur, gardez au moins un outil coché."
        },
        "column": {
            "permissions": "Autorisations MCP"
        },
        "badge": {
            "unrestricted": "Illimité (tous les outils)"
        },
        "filter": {
            "tools": "Filtrer les outils…"
        },
        "action": {
            "selectAll": "Tout cocher",
            "clearAll": "Tout décocher"
        },
        "save": "Enregistrer",
        "loadError": "Échec du chargement des autorisations des outils",
        "emptyWarn": {
            "header": "Une liste vide accorde TOUS les outils",
            "message": "Ces utilisateurs auraient une liste d’autorisations vide, qui accorde actuellement TOUS les outils (politique provisoire) : {users}. Pour réellement les restreindre, gardez au moins un outil coché. Enregistrer quand même ?",
            "accept": "Enregistrer quand même"
        },
        "dialog": {
            "title": "Autorisations MCP — {name}",
            "saved": "Autorisations MCP mises à jour",
            "saveError": "Échec de la mise à jour des autorisations MCP"
        }
    }
}
